import type { GetEGiftCardDetailResponse, MerchantEGiftCard } from "../types/eGiftCard.types";
import type { EGiftCardFormData } from "../types/eGiftCardForm.types";
import { getBrowserTimeZone } from "../../../lib/date-time";

export const mapEGiftCardDetailToFormData = (
  eGiftCardDetail: GetEGiftCardDetailResponse,
): EGiftCardFormData => {
  const merchantBrandItemId = eGiftCardDetail.merchant_brand_item_id;
  const rewardName =
    eGiftCardDetail.reward_name ||
    eGiftCardDetail.name ||
    String(eGiftCardDetail.value);
  const name = eGiftCardDetail.name || rewardName;

  const eGiftCard: MerchantEGiftCard = {
    id: merchantBrandItemId,
    coupon_id: eGiftCardDetail.id,
    value: merchantBrandItemId,
    label: name,
    merchant_brand_id: eGiftCardDetail.merchant_id,
    name,
    reward_name: rewardName,
    points: eGiftCardDetail.points_required,
    faceValue: eGiftCardDetail.value,
    quantity: eGiftCardDetail.quantity,
    used_quantity: eGiftCardDetail.used_quantity,
    disabled: true,
    is_existing: true,
  };

  return {
    merchantBrandId: eGiftCardDetail.merchant_id,
    giftCardIds: [merchantBrandItemId],
    giftCardItems: [eGiftCard],
    validFrom: eGiftCardDetail.valid_from ? new Date(eGiftCardDetail.valid_from) : undefined,
    validTo: eGiftCardDetail.valid_to ? new Date(eGiftCardDetail.valid_to) : undefined,
    timezone: getBrowserTimeZone(),
    isAlertLowStock: eGiftCardDetail.is_alert_low_stock,
  };
};
